<template>
  <refonte-page-alert
    v-bind:description_in_card="true"
    v-bind:alert_type="'error'"
    v-bind:end_date="'2026-10-13T00:00:00'">
    Bonjour,<br />
    Dans le cadre d’une opération technique,
    <b
      >les espaces JINIUS seront temporairement indisponibles le lundi 12
      octobre de 19h à 24h</b
    >. <br />Durant cette période, il ne sera pas possible d’accéder aux
    portails ni aux services associés. Le rétablissement du service est prévu
    <b>à partir de 01h .</b><br />
    Nous vous remercions pour votre compréhension et vous prions de nous excuser
    pour la gêne occasionnée.<br />
    L’équipe JINIUS
  </refonte-page-alert>
  <refonte-page-alert
    v-bind:description_in_card="true"
    v-bind:alert_type="'error'"
    v-bind:start_date="'2026-04-08T05:00:00'"
    v-bind:end_date="'2026-04-13T08:00:00'">
    La plateforme JINIUS sera indisponible le lundi 13/4 entre 7h et 9h pour une
    intervention technique. Veuillez nous excuser pour la gêne occasionnée.
  </refonte-page-alert>

  <refonte-page-title v-bind:description_in_card="true">
    Bienvenue dans votre Espace Participant JINIUS.
    <br /><br />
    Cet espace a été conçu pour vous offrir un accès simple et rapide à toutes
    les informations concernant vos formations.
    <br />L'écran d'accueil vous fournit les actions à réaliser pour compléter
    vos formations.

    <div v-if="profile.entreprise">
      Pour accéder aux informations de gestion de vos inscriptions (commandes,
      conventions, factures, certificats) allez dans votre
      <router-link
        to="/gestion/accueil"
        class="text-refonte_blue-600 underline">
        Espace Gestion</router-link
      >.
    </div>
  </refonte-page-title>

  <refonte-page-alert
    v-bind:description_in_card="true"
    v-bind:alert_type="'news'">
    <strong>Nouveau</strong> : La <u>signature électronique</u> est désormais
    disponible pour les Protocoles Individuels de Formation (PIF). Pour plus
    d'informations, vous pouvez consulter le
    <a
      v-bind:href="`${cdn_url}/aide-en-ligne/050626_PIF__Espace-Participant_Guide-signature-elec.pdf`"
      class="alert-link"
      target="_blank"
      rel="noopener noreferrer">
      Guide Utilisateur</a
    >.
    <br />
  </refonte-page-alert>

  <refonte-collapse
    class="mt-[12px]"
    v-bind:title_icon="IconFormations"
    title="Mes formations"
    v-bind:start_open="true">
    <div class="btn-dashbord-container">
      <template v-if="!indicateurLoading">
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push('/inscription/formations?action=T_POS_A_EFFECTUER')
          ">
          <span
            >Vous avez
            <b>{{
              indicateurs.nombreFormationsTestsPositionnementNonRealise
            }}</b
            >test(s) de positionnement à remplir pour valider votre
            inscription.</span
          >
          <br />
          <span class="!text-sm italic text-core-500"
            >Ne tardez pas à les finaliser afin de confirmer votre inscription.
          </span>
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/inscription/formations?action=T_VALIDATION_NON_REALISE&affichage=FORMATIONS_PASSEES'
              )
          ">
          <span
            >Il vous reste
            <b>{{ indicateurs.nombreFormationsTestsValidationNonRealise }}</b
            >test(s) de validation des acquis à effectuer.
          </span>
          <br />
          <span class="!text-sm italic text-core-500"
            >Ces étapes sont indispensables pour accéder à vos attestations.
          </span>
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/inscription/formations?action=MODULE_ELEARNING_A_DEBUTER'
              )
          ">
          <span
            >Vous avez <b>{{ indicateurs.nombreFormationsElearningADebuter }}</b
            >module(s) elearning à débuter.</span
          >
          <br />
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/inscription/formations?action=MODULE_ELEARNING_A_TERMINER'
              )
          ">
          <span
            >Vous avez
            <b>{{ indicateurs.nombreFormationsElearningATerminer }}</b
            >module(s) elearning à terminer.</span
          >
          <br />
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="() => router.push('/inscription/formations')">
          <span
            >Vous avez <b>{{ indicateurs.nombreFormationsFuture }}</b
            >formation(s) à venir/en cours.</span
          >
          <br />
        </refonte-button>
        <refonte-button
          variant="secondary"
          class="btn-dashboard"
          v-bind:on_click="
            () =>
              router.push(
                '/inscription/formations?affichage=FORMATIONS_PASSEES'
              )
          ">
          <span
            >Vous avez <b>{{ indicateurs.nombreAttestations }}</b
            >attestation(s) disponible(s).</span
          >
          <br />
        </refonte-button>

        <div>
          <refonte-separator />
          <refonte-button
            variant="text"
            v-bind:on_click="() => router.push('/inscription/formations')">
            Retrouvez vos formations dans le menu « Mes formations ».
          </refonte-button>
        </div>
      </template>
      <spinner
        v-else
        sizes="w-20 h-20"
        thickness="border-8" />
    </div>
  </refonte-collapse>
</template>
<script setup lang="ts">
  import RefontePageAlert from '@/components/refonte/alerts/refonte-page-alert.vue';
  import RefontePageTitle from '@/components/refonte/titles/refonte-page-title.vue';
  import RefonteCollapse from '@/components/refonte/collapse/refonte-collapse.vue';
  import IconFormations from '@/assets/img/refonte/icons/menu/icon-training.svg?component';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import RefonteSeparator from '@/components/refonte/separators/refonte-separator.vue';
  import { router } from '@/router';
  import { onMounted, ref } from 'vue';
  import Spinner from '@/components/utils/spinner.vue';
  import { API } from '@/http-common';
  import { Indicateurs } from '@/types/participant/indicateurs-types';
  import { useAccountStore } from '@/stores/account';
  import { storeToRefs } from 'pinia';
  import { map_domain_per_env } from '@/assets/data/data_maps';

  const indicateurLoading = ref<boolean>(true);

  const accountStore = useAccountStore();
  const { profile } = storeToRefs(accountStore);
  onMounted(async () => {
    indicateurLoading.value = true;
    await fetchData();
    indicateurLoading.value = false;
  });

  const cdn_url = `https://cdn.${
    map_domain_per_env[import.meta.env.VITE_CONTEXT]
  }`;

  const indicateurs = ref<Indicateurs>({
    nombreFormationsTestsPositionnementNonRealise: 0,
    nombreFormationsTestsValidationNonRealise: 0,
    nombreFormationsElearningADebuter: 0,
    nombreFormationsElearningATerminer: 0,
    nombreFormationsFuture: 0,
    nombreAttestations: 0
  });
  const fetchData = async () => {
    const response = await API.get(`participant/v2/indicateurs`);
    if (response?.data) {
      indicateurs.value = response.data;
    }
  };
</script>

<style lang="scss" scoped>
  .btn-dashbord-container {
    @apply flex flex-col;
    margin-bottom: 8px;
    gap: 8px;
    padding: 0 10px;

    .btn-dashboard {
      @apply w-full justify-between text-left text-refonte-black;
      max-width: 100% !important;

      b {
        @apply mr-1 text-refonte_blue-600;
      }
    }
    :deep(.refonte-btn.btn-secondary span) {
      overflow: initial;
      text-overflow: initial;
      display: initial;
      -webkit-box-orient: initial;
      -webkit-line-clamp: initial;
      font-size: 14px;
      font-weight: 400;
      line-height: 125%;
    }
  }
</style>
